import React, { useContext, useEffect, useRef, useState } from "react";
import Layout from "../CommonComponents/Layout/Layout";
import { SIDER_TABS } from "../../utils/Constants";

import dayjs from "dayjs";

import "./stylesDashboard.css";
import TopSection from "./TopSection/TopSection";
import DashboardLineChart from "../CommonComponents/Dashboard/DashboardLineChart/DashboardLineChart";
import PlatformOverviewChart from "../CommonComponents/Dashboard/PlatformOverviewChart/PlatformOverviewChart";
import UserCountsPriorMonthChart from "../CommonComponents/Dashboard/UserCountsPriorMonthChart/UserCountsPriorMonthChart";
import AffiliatesTable from "../CommonComponents/Dashboard/AffiliatesTable/AffiliatesTable";
import DashboardPieChart from "../CommonComponents/Dashboard/DashboardPieChart/DashboardPieChart";
import NewUsersByChannelChart from "../CommonComponents/Dashboard/NewUsersByChannelChart/NewUsersByChannelChart";
import DashboardBarChart from "../CommonComponents/Dashboard/DashboardBarChart/DashboardBarChart";
import RegistrationTrendsChart from "../CommonComponents/Dashboard/RegistrationTrendsChart/RegistrationTrendsChart";
import ChurnRiskTable from "../CommonComponents/Dashboard/ChurnRiskTable/ChurnRiskTable";
import SportPerformanceTable from "../CommonComponents/Dashboard/SportPerformanceTable/SportPerformanceTable";
import SportsBook from "./SportsBook/SportsBook";
import Promos from "./Promos/Promos";
import BettorsBettingBehavior from "./BettorsBettingBehavior/BettorsBettingBehavior";
import KeyFeatures from "./KeyFeatures/KeyFeatures";
import DeviceTypeDistribution from "./DeviceTypeDistribution/DeviceTypeDistribution";
import { Tabs } from "antd";
import CustomDatePicker from "../CommonComponents/CustomDatePicker/CustomDatePicker";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import Casino from "./Casino/Casino";
import { set } from "date-fns";
import AppContext from "../../context/AppContext";

function Dashboard() {
  // const { setActiveSidebarTab } = useContext(AppContext);
  // setActiveSidebarTab(SIDER_TABS.DASHBOARD);

  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken,
    true
  );

  const [startDate, setStartDate] = useState(new Date());
  const [activeTab, setActiveTab] = useState("Transactions");
  const tabs = ["All", "Transactions", "Platform"];

  const isTopSectionFirstRender = useRef(true);
  const isPromoDataFirstRender = useRef(true);
  const isSportsBookDataFirstRender = useRef(true);
  const isPlatformOverviewSectionFirstRender = useRef(true);
  const isCasinoDataFirstRender = useRef(true);

  const kpisPlayers = {
    labels: [
      "Aug 20",
      "Sep 20",
      "Oct 20",
      "Nov 20",
      "Dec 20",
      "Jan 21",
      "Feb 21",
      "Mar 21",
    ],
    datasets: [
      {
        label: "Kpis",
        data: [20000, 25000, 30000, 40000, 32000, 31000, 28000, 24000],
        borderColor: "#EE72BC",
        backgroundColor: "#EE72BC",
        borderRadius: 1,
        pointRadius: 0,
        pointHoverRadius: 0,
      },
    ],
    headers: [
      { title: "Total Players", amount: 34520, percentage: 7 },
      { title: "Active Players", amount: 15000, percentage: 5 },
      { title: "Sessions", amount: 18900, percentage: 10 },
      { title: "Player churn", amount: 1000, percentage: -3 },
    ],
  };

  const kpis2 = {
    headers: [
      { title: "Total Rebet Free Cash Awared", amount: 50000, percentage: 10 },
      { title: "Total Rebet Free Cash Wagered", amount: 35000, percentage: 7 },
      { title: "Total Free Bonus Bets Placed", amount: 2500, percentage: 5 },
    ],
  };

  const pieData2 = [
    { device: "0-0.25", count: 1000, color: "#F1C40F" },
    { device: "0.25-0.5", count: 2000, color: "#F39C12" },
    { device: "0.5-0.75", count: 3000, color: "#FD6F27" },
    { device: "0.76-0.99", count: 4000, color: "#E74C3C" },
  ];

  const data = {
    labels: [
      "Aug 20",
      "Sep 20",
      "Oct 20",
      "Nov 20",
      "Dec 20",
      "Jan 21",
      "Feb 21",
      "Mar 21",
    ],
    datasets: [
      {
        label: "30 days",
        data: [20000, 25000, 30000, 40000, 32000, 31000, 28000, 24000],
        borderColor: "#6177E8",
        backgroundColor: "#6177E8",
        borderRadius: 1,
        pointRadius: 0,
        pointHoverRadius: 0,
      },
      {
        label: "7 days",
        data: [10000, 15000, 10000, 20000, 14000, 11000, 18000, 14000],
        borderColor: "#9B59B6",
        backgroundColor: "#9B59B6",
        borderRadius: 1,
        pointRadius: 0,
        pointHoverRadius: 0,
      },
      {
        label: "1 day",
        data: [5000, 5000, 6000, 7000, 4000, 1000, 8000, 4000],
        borderColor: "#3498DB",
        backgroundColor: "#3498DB",
        borderRadius: 1,
        pointRadius: 0,
        pointHoverRadius: 0,
      },
    ],
  };

  const firstTimeActivePlayersData = {
    labels: Array.from({ length: 30 }, (_, i) => `Sep ${i + 1}`),
    datasets: [
      {
        data: Array.from(
          { length: 30 },
          () => Math.floor(Math.random() * 10000) + 1000
        ),
        backgroundColor: ["#6177E8"],
        borderColor: ["#6177E8"],
        borderWidth: 1,
        borderRadius: 4,
      },
    ],
  };

  const registrationTrendsData = {
    labels: [
      "Aug 20",
      "Aug 21",
      "Aug 22",
      "Aug 23",
      "Aug 24",
      "Aug 25",
      "Aug 26",
      "Aug 27",
      "Aug 28",
      "Aug 29",
      "Aug 30",
      "Aug 31",
      "Sep 1",
      "Sep 2",
      "Sep 3",
      "Sep 4",
      "Sep 5",
    ],
    datasets: [
      {
        label: "Downloads",
        data: [
          3000, 5000, 6000, 7000, 8000, 4000, 10000, 11000, 12000, 11000, 12000,
          11000, 10000, 9000, 8000, 7000, 6000,
        ],
        borderColor: "#FFFFFF",
        backgroundColor: "#FFFFFF",
        borderWidth: 2,
        pointHoverRadius: 0,
        pointRadius: 0,
        fill: true,
        type: "line",
        tension: 0.1,
      },
      {
        label: "Without a referral code",
        data: [
          10000, 25000, 26000, 30000, 32000, 31000, 30000, 29000, 28000, 27000,
          26000, 25000, 24000, 23000, 22000, 21000, 20000,
        ],
        borderColor: "#9B59B6",
        backgroundColor: "#9B59B6",
        borderRadius: 5,
        pointRadius: 0,
        pointHoverRadius: 0,
        type: "bar",
      },
      {
        label: "With a referral code",
        data: [
          12000, 26000, 27000, 31000, 29000, 38000, 38000, 34000, 33000, 28000,
          31000, 32000, 33000, 24000, 35000, 36000, 37000,
        ],
        borderColor: "#71BF8A",
        backgroundColor: "#71BF8A",
        borderRadius: 5,
        pointRadius: 0,
        pointHoverRadius: 0,
        type: "bar",
      },
    ],
  };

  const percentileData = {
    labels: [
      "Aug 20",
      "Aug 21",
      "Aug 22",
      "Aug 23",
      "Aug 24",
      "Aug 25",
      "Aug 26",
      "Aug 27",
      "Aug 28",
      "Aug 29",
      "Aug 30",
      "Aug 31",
      "Sep 1",
      "Sep 2",
      "Sep 3",
      "Sep 4",
      "Sep 5",
    ],

    datasets: [
      {
        label: "Dormant",
        data: [
          2000, 2100, 2200, 2300, 2400, 2500, 2600, 2700, 2800, 2900, 3000,
          3100, 3200, 3300, 3400, 3500, 3600,
        ],
        borderColor: "#1ABC9C",
        backgroundColor: "#1ABC9C",
        borderRadius: 5,
        pointRadius: 0,
        pointHoverRadius: 0,
      },
      {
        label: "Reactivated",
        data: [
          3000, 3200, 3400, 3600, 3800, 4000, 4200, 4400, 4600, 4800, 5000,
          5200, 5400, 5600, 5800, 6000, 6200,
        ],
        borderColor: "#9B59B6",
        backgroundColor: "#9B59B6",
        borderRadius: 5,
        pointRadius: 0,
        pointHoverRadius: 0,
      },
      {
        label: "New",
        data: [
          8000, 8200, 8300, 8400, 8500, 8600, 8800, 9000, 9200, 9400, 9600,
          9800, 10000, 10200, 10400, 10600, 10800,
        ],
        borderColor: "#71BF8A",
        backgroundColor: "#71BF8A",
        borderRadius: 5,
        pointRadius: 0,
        pointHoverRadius: 0,
      },
      {
        label: "Lapsed",
        data: [
          5000, 5200, 5300, 5400, 5500, 5600, 5800, 6000, 6200, 6400, 6600,
          6800, 7000, 7200, 7400, 7600, 7800,
        ],
        borderColor: "#E74C3C",
        backgroundColor: "#E74C3C",
        borderRadius: 5,
        pointRadius: 0,
        pointHoverRadius: 0,
      },
      {
        label: "Active",
        data: [
          15000, 14000, 14500, 14800, 15200, 15500, 16000, 16500, 17000, 17200,
          17500, 17800, 18000, 18500, 19000, 19500, 20000,
        ],
        borderColor: "#6177E8",
        backgroundColor: "#6177E8",
        borderRadius: 5,
        pointRadius: 0,
        pointHoverRadius: 0,
      },
    ],
  };

  const MarketingSection = () => {
    return (
      <>
        <div className="row">
          <NewUsersByChannelChart />
          <DashboardPieChart title="Churn rate based" pieData={pieData2} />
        </div>
        <div className="row">
          <DashboardBarChart
            data={firstTimeActivePlayersData}
            title="First time active Players"
          />
          <DashboardBarChart
            data={firstTimeActivePlayersData}
            title="Active Players"
          />
        </div>
        <div className="row">
          <RegistrationTrendsChart
            title="Percentile - Lifecycle Satages"
            data={percentileData}
          />
          <RegistrationTrendsChart
            title="Total - Lifecycle Satages"
            data={percentileData}
          />
        </div>
        <AffiliatesTable />
      </>
    );
  };

  const todayRange = [dayjs(), dayjs()];
  const formattedTodayRange = `start_date=${todayRange[0].format(
    "YYYY-MM-DD"
  )}&end_date=${todayRange[1].format("YYYY-MM-DD")}`;

  const [isApiPlatformOverviewRunning, setIsApiPlatformOverviewRunning] =
    useState(false);
  const [isApiKeyFeaturesRunning, setIsApiKeyFeaturesRunning] = useState(false);
  const [
    isApiBettorsBettingBehaviorRunning,
    setIsApiBettorsBettingBehaviorRunning,
  ] = useState(false);

  const [platformOverviewData, setPlatformOverviewData] = useState({});
  const [platformOverviewDates, setPlatformOverviewDates] =
    useState(todayRange);

  const [deviceTypeData, setDeviceTypeData] = useState({
    total_logins: 0,
    percentage_distribution: {
      ios: 0,
      web: 0,
      android: 0,
    },
  });

  const [keyFeaturesData, setKeyFeaturesData] = useState({
    rebet_button: 74281,
    peer_to_peer: 813,
    easy_to_read_lines: 0,
    social_interactions: {
      total: 29562,
      comments: 6393,
      likes: 23169,
      shares: 0,
    },
  });

  const [bettorsBettingBehaviorData, setBettorsBettingBehaviorData] = useState({
    only_rcash_player: 0,
    only_rcash_percentage: 0,
    only_rcoin_player: 0,
    only_rcoin_percentage: 0,
    both_player: 0,
    both_player_percentage: 0.0,
    not_played: 0,
    not_played_percentage: 0.0,
    total_user: 0,
  });

  const getPlatformOverviewData = async (queryString) => {
    setIsApiPlatformOverviewRunning(true);
    setIsApiKeyFeaturesRunning(true);
    setIsApiBettorsBettingBehaviorRunning(true);

    if (!queryString) {
      queryString = formattedTodayRange;
    }

    const platformStatisticsUrl =
      "/dashboard/platform/platform-statistics?" + queryString;
    const keyFeaturesUsageUrl =
      "/dashboard/platform/key-feature-usage?" + queryString;
    const bettoBehaviorUrl =
      "/dashboard/platform/bettor-behavior?" + queryString;

    try {
      const requests = [
        PrivateAdminPanelInstance?.get(platformStatisticsUrl),
        PrivateAdminPanelInstance?.get(keyFeaturesUsageUrl),
        PrivateAdminPanelInstance?.get(bettoBehaviorUrl),
      ];
      const responses = await Promise.allSettled(requests);

      const [
        platformStatisticsResponse,
        keyFeaturesUsageResponse,
        bettorBehaviorResponse,
      ] = responses;

      if (platformStatisticsResponse.status === "fulfilled") {
        const platformStatisticsData =
          platformStatisticsResponse.value.data.data;

        setPlatformOverviewData(platformStatisticsData.platform_overview);
        setDeviceTypeData(platformStatisticsData.device_type_distribution);
      }

      if (keyFeaturesUsageResponse.status === "fulfilled") {
        const keyFeaturesUsageData = keyFeaturesUsageResponse.value.data.data;

        setKeyFeaturesData(keyFeaturesUsageData);
      }

      if (bettorBehaviorResponse.status === "fulfilled") {
        const bettorBehaviorData = bettorBehaviorResponse.value.data.data.test;

        setBettorsBettingBehaviorData(bettorBehaviorData);
      }
    } catch (error) {
      console.log("error dashboard platform data", error);
    } finally {
      setIsApiPlatformOverviewRunning(false);
      setIsApiKeyFeaturesRunning(false);
      setIsApiBettorsBettingBehaviorRunning(false);
    }
  };

  const PlatformSection = () => {
    return (
      <>
        <div className="column">
          <div className="row">
            <CustomDatePicker
              getData={getPlatformOverviewData}
              dates={platformOverviewDates}
              setDates={setPlatformOverviewDates}
            />
          </div>
          <div className="row">
            <PlatformOverviewChart
              isApiPlatformOverviewRunning={isApiPlatformOverviewRunning}
              platformOverviewData={platformOverviewData}
              getPlatformOverviewData={getPlatformOverviewData}
              isPlatformOverviewSectionFirstRender={
                isPlatformOverviewSectionFirstRender
              }
            />
            <DeviceTypeDistribution
              deviceTypeData={deviceTypeData}
              isApiPlatformOverviewRunning={isApiPlatformOverviewRunning}
            />
          </div>
        </div>
        <div className="row" style={{ marginTop: "20px" }}>
          <KeyFeatures
            keyFeaturesData={keyFeaturesData}
            isApiKeyFeaturesRunning={isApiKeyFeaturesRunning}
          />
          <BettorsBettingBehavior
            bettorsBettingBehaviorData={bettorsBettingBehaviorData}
            isApiBettorsBettingBehaviorRunning={
              isApiBettorsBettingBehaviorRunning
            }
          />
        </div>
        {/* <SportPerformanceTable />
        <DashboardLineChart
          title="User activity over time"
          headers={false}
          data={data}
        />

        <UserCountsPriorMonthChart title="User counts compared to the prior month" /> */}
      </>
    );
  };

  const [isApiTopSectionRunning, setIsApiTopSectionRunning] = useState(false);
  const [overallData, setOverallData] = useState({});
  const [topSectionDates, setTopSectionDates] = useState(todayRange);

  const [isApiPromosRunning, setIsApiPromosRunning] = useState(false);
  const [promosData, setPromosData] = useState({});
  const [promoSectionDates, setPromoSectionDates] = useState(todayRange);

  const [isApiSportsBookRunning, setIsApiSportsBookRunning] = useState(false);
  const [turnOverData, setTurnOverData] = useState({
    total_turnover: {},
    sportradar_turnover: {},
    dst_turnover: {},
    oddin_turnover: {},
    sum_sportradar_turnover: "0.00",
    sum_dst_turnover: "0.00",
    sum_oddin_turnover: "0.00",
    sum_turnover: "0.00",
    previous_sum_turnover: 0,
    change_percentage_turnover: 0,
  });
  const [ggrData, setGgrData] = useState({
    total_ggr: {},
    sportradar_ggr: {},
    dst_ggr: {},
    oddin_ggr: {},
    sum_sportradar_ggr: "0.00",
    sum_dst_ggr: "0.00",
    sum_oddin_ggr: "0.00",
    sum_ggr: "0.00",
    previous_sum_ggr: 0,
    change_percentage_ggr: 0,
  });
  const [sportsBooksSectionDates, setSportsBooksSectionDates] =
    useState(todayRange);

  const [isApiCasinoRunning, setIsApiCasinoRunning] = useState(false);
  const [turnOverCasinoData, setTurnOverCasinoData] = useState({});
  const [ggrCasinoData, setGgrCasinoData] = useState({});
  const [casinoSectionDates, setCasinoSectionDates] =
    useState(todayRange);

  const FinanceSection = () => {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        <TopSection
          isApiRunning={isApiTopSectionRunning}
          setIsApiRunning={setIsApiTopSectionRunning}
          overallData={overallData}
          setOverallData={setOverallData}
          isTopSectionFirstRender={isTopSectionFirstRender}
          topSectionDates={topSectionDates}
          setTopSectionDates={setTopSectionDates}
        />
        <SportsBook
          isApiRunning={isApiSportsBookRunning}
          setIsApiRunning={setIsApiSportsBookRunning}
          turnOverData={turnOverData}
          setTurnOverData={setTurnOverData}
          ggrData={ggrData}
          setGgrData={setGgrData}
          isSportsBookDataFirstRender={isSportsBookDataFirstRender}
          sportsBooksSectionDates={sportsBooksSectionDates}
          setSportsBooksSectionDates={setSportsBooksSectionDates}
        />
        <Casino
          isApiRunning={isApiCasinoRunning}
          setIsApiRunning={setIsApiCasinoRunning}
          turnOverData={turnOverCasinoData}
          setTurnOverData={setTurnOverCasinoData}
          ggrData={ggrCasinoData}
          setGgrData={setGgrCasinoData}
          isCasinoDataFirstRender={isCasinoDataFirstRender}
          casinosSectionDates={casinoSectionDates}
          setCasinosSectionDates={setCasinoSectionDates}
        />
        <Promos
          isApiRunning={isApiPromosRunning}
          setIsApiRunning={setIsApiPromosRunning}
          promosData={promosData}
          setPromosData={setPromosData}
          isPromoDataFirstRender={isPromoDataFirstRender}
          promoSectionDates={promoSectionDates}
          setPromoSectionDates={setPromoSectionDates}
        />
      </div>
    );
  };

  const { setActiveSidebarTab } = useContext(AppContext);

  useEffect(() => {
    setActiveSidebarTab(SIDER_TABS.DASHBOARD, "Dashboard");
  }, [setActiveSidebarTab]);

  return (
    <Layout name={SIDER_TABS?.DASHBOARD}>
      <div className="dashboard-body-container">
        <h2>Dashboard</h2>
        <div className="dashboard-tabs">
          {tabs.map((tab, index) => (
            <button
              key={index}
              className={activeTab === tab ? "active" : null}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        {(activeTab === "Transactions" || activeTab === "All") && <FinanceSection />}
        {(activeTab === "Platform" || activeTab === "All") && PlatformSection()}
        {/* {(activeTab === "Players" || activeTab === "All") && (
          <>
            <DashboardLineChart
              headers={kpisPlayers.headers}
              data={kpisPlayers}
            />
            <DashboardLineChart
              title="Player activity over time"
              headers={false}
              data={data}
            />
            <UserCountsPriorMonthChart title="Player counts compared to the prior month" />
            <RegistrationTrendsChart
              title="Registration trends"
              topContent={true}
              data={registrationTrendsData}
            />
            <ChurnRiskTable />
          </>
        )} */}
        {/* {(activeTab === "Marketing" || activeTab === "All") &&
          MarketingSection()}
        {(activeTab === "Platform" || activeTab === "All") && PlatformSection()} */}
      </div>
    </Layout>
  );
}

export default Dashboard;
